export default {
  // Make the padding smaller and more consistent with button groups
  sizeSmall: {
    paddingTop: 3,
    paddingBottom: 3,
  },
};
